import axiosLimiter from '@/api/RateLimiter';

export default {
  async getAllCollectionPages(tenant: string, params: any = {}): Promise<any> {
    const requests = [];
    let currentPage = 1;
    let totalPages = null;
    let nextPageLink = null;

    while (totalPages === null || currentPage < totalPages + 1) {
      let requestURL =
        process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenant +
        '/views?';

      if (
        'entityType' in params &&
        params.entityType &&
        params.entityType.length > 0
      ) {
        requestURL =
          requestURL + '&entityType=' + encodeURIComponent(params.entityType);
      }
      if (
        'createdFrom' in params &&
        params.createdFrom &&
        params.createdFrom.length > 0
      ) {
        requestURL =
          requestURL + '&createdFrom=' + encodeURIComponent(params.createdFrom);
      }
      if (
        'createdUntil' in params &&
        params.createdUntil &&
        params.createdUntil.length > 0
      ) {
        requestURL =
          requestURL +
          '&createdUntil=' +
          encodeURIComponent(params.createdUntil);
      }

      if (nextPageLink) {
        requestURL = process.env.VUE_APP_BASCLOUD_SERVER_URL + nextPageLink;
      }

      const response: Promise<any> = axiosLimiter.get(requestURL);

      if (totalPages === null || currentPage < totalPages + 1) {
        const results: any = await response;
        totalPages = parseInt(results.data.meta.page.totalPages);
        nextPageLink = results.data.links.next;
      }

      requests.push(response);
      currentPage++;
    }

    return Promise.all(requests);
  },

  getSingle(tenant: string, viewUUID: string): Promise<any> {
    return axiosLimiter.get(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenant +
        '/views/' +
        viewUUID
    );
  },

  create(
    tenantUUID: string,
    description: string,
    entityType: string,
    requestType: string,
    requestConfig: any
  ): Promise<any> {
    const body = {
      data: {
        type: 'views',
        attributes: {
          description,
          entityType,
          requestType,
          requestConfig,
        },
      },
    } as any;

    return axiosLimiter.post(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/views',
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/vnd.api+json' } }
    );
  },

  update(
    tenantUUID: string,
    viewUUID: string,
    description?: string,
    entityType?: string,
    requestType?: string,
    requestConfig?: any
  ): Promise<any> {
    const body = {
      data: {
        type: 'views',
        id: viewUUID,
        attributes: {},
      },
    } as any;

    if (description !== undefined && description.length > 0) {
      body.data.attributes.description = description;
    }
    if (entityType !== undefined && entityType.length > 0) {
      body.data.attributes.entityType = entityType;
    }
    if (requestType !== undefined && requestType.length > 0) {
      body.data.attributes.requestType = requestType;
    }
    if (requestConfig !== undefined) {
      body.data.attributes.requestConfig = requestConfig;
    }

    return axiosLimiter.patch(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/views/' +
        viewUUID,
      JSON.stringify(body),
      { headers: { 'Content-Type': 'application/vnd.api+json' } }
    );
  },

  delete(tenantUUID: string, viewUUID: string): Promise<any> {
    return axiosLimiter.delete(
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
        '/tenants/' +
        tenantUUID +
        '/views/' +
        viewUUID
    );
  },

  getData(
    tenantUUID: string,
    viewUUID: string,
    params: any = {}
  ): Promise<any> {
    let requestURL =
      process.env.VUE_APP_BASCLOUD_SERVER_URL +
      '/tenants/' +
      tenantUUID +
      '/views/' +
      viewUUID +
      '/data?';

    Object.keys(params || {}).forEach((key: string) => {
      const val = (params as any)[key];
      if (val === undefined || val === null || val === '') return;
      requestURL =
        requestURL +
        '&' +
        encodeURIComponent(key) +
        '=' +
        encodeURIComponent(val);
    });

    return axiosLimiter.get(requestURL);
  },
};
